// client/src/services/api.js
import axios from "axios";
import { devError } from "../utils/devLog";

const getBaseURL = () => {
  if (import.meta.env.DEV) {
    return "/api-coldcase";
  }

  const raw = import.meta.env.VITE_API_TARGET || import.meta.env.VITE_API_URL;
  const trimmed = String(raw || "").replace(/\/+$/, "");
  return trimmed.endsWith("/api-coldcase") ? trimmed : `${trimmed}/api-coldcase`;
};

export const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add Clerk user ID to requests
api.interceptors.request.use(async (config) => {
  try {
    const userId = window.Clerk?.user?.id;
    if (userId) {
      config.headers["x-user-id"] = userId;
    }
  } catch (error) {
    devError("api", "request_auth_header_failed", {
      message: error.message,
      stack: error.stack,
      hasClerk: !!window.Clerk,
      hasUser: !!window.Clerk?.user,
      url: config.url,
      method: config.method,
    });
  }
  return config;
});

// Enhanced error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === "ERR_NETWORK") {
      devError("api", "network_error", {
        message: error.message,
        baseURL: api.defaults.baseURL,
      });
    }
    devError("api", "response_error", {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      data: error.response?.data,
      url: error.config?.url,
      method: error.config?.method,
    });
    throw error;
  }
);
